export default function Layout({ children }) {
  return <div className="min-h-screen bg-background py-20">{children}</div>;
}
